const KURUCULAR = [
  { name: "Kasım Vural", title: "CEO (Vural İnşaat)" },
  { name: "Fahrettin Esin", title: "Emekli Öğretmen" },
  { name: "Hamza Atabay", title: "İş İnsanı" },
  { name: "Nurten Bulut", title: "Kadın Kolları Başkan" },
  { name: "Fuat Taşdelen", title: "Avukat (Taşdelen Hukuk)" },
  { name: "Şeref Aras", title: "İş İnsanı" },
  { name: "Muhammet Güler", title: "CEO (Güler İnşaat)" },
  { name: "Yunus Esen", title: "Genel Müdür (Esen Sofrası)" },
  { name: "Kurban Yorulmaz", title: "İçişleri Uzmanı (İçişleri Bakanlığı)" },
  { name: "Metin İlhan", title: "Yazılım Mühendisi (Huawei)" },
  { name: "İlhan Kanatlı", title: "İş İnsanı" },
  { name: "Önder Kaçar", title: "İş İnsanı" },
  { name: "Murat Baysoy", title: "İş İnsanı" },
  { name: "Kamuran Vural", title: "İş İnsanı" },
  { name: "Hamdullah Kılıç", title: "İş İnsanı" },
  { name: "Ömer Kahriman", title: "İş İnsanı" },
  { name: "Mehmet Polat", title: "İş İnsanı" },
  { name: "Sertaç Bektaş", title: "İş İnsanı" },
  { name: "Erhan Sancar", title: "İş İnsanı" },
  { name: "Mahmut Aydemir", title: "İş İnsanı" },
];

export default KURUCULAR;
